import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import OperationService from '../../../../services/OperationService';

import './ExportPdf.css';


class ExportPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: true
        };
    }

    render() {
        return (
            <RaisedButton className="footerButton" label="PDF" secondary disabled={!this.state.loaded} onClick={() => {this.downloadPDF()}}/>
        )
    }

    /**
     * Appel WS pour la récupération du pdf
     */
    downloadPDF() {
        this.setLoaded(false);
        if (!this.props.fundingDate && !this.props.startLocalDate && !this.props.endLocalDate) {
            return;
        }

        if (this.props.fundingDate) {
            OperationService.getPDF(this.props.fundingDate, this.props.idBu, this.props.idShop, this.props.financingDate, this.props.selectedStreamType, this.props.selectedCardTypes, this.props.selectedActivities , this.props.detailsDateTransaction, this.setLoaded.bind(this));
        }

        if (this.props.startLocalDate && this.props.endLocalDate) {
            OperationService.getPeriodicPDF(this.props.startLocalDate, this.props.endLocalDate, this.props.idShop, this.props.idBu, this.props.selectedStreamType, this.props.selectedCardTypes, this.props.selectedActivities , this.props.detailsDateTransaction, this.setLoaded.bind(this));
        }
    }

    /**********************************************************
     ********************* Loader *****************************
     **********************************************************/

    /**
     * On active/désactive le loader
     * @param loaded
     */
    setLoaded(loaded) {
        this.setState({
            loaded: loaded
        });
    }
}

export default ExportPdf;



// WEBPACK FOOTER //
// ./src/components/tableComponent/export/pdf/ExportPdf.js